module.exports = __webpack_public_path__ + "img/127.ebde0a88.jpg";